import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import SortableEntityTableRow, {
  SortableEntityTableRowProps,
} from 'components/SortableEntityTableRow';
import TableCell from 'components/TableCell';

import { MenuItemsListRow_menuItem$key } from '__generated__/MenuItemsListRow_menuItem.graphql';

type Props = SortableEntityTableRowProps & {
  menuItem: MenuItemsListRow_menuItem$key;
};

const types = {
  PAGE: 'Puslapis',
  PACKAGES: 'Kelionės',
  ARTICLES: 'Ką pamatyti',
  EXTERNAL: 'Išorinis URL',
};

const MenuItemsListRow: FC<Props> = ({ menuItem, ...props }) => {
  const menuItemData = useFragment(
    graphql`
      fragment MenuItemsListRow_menuItem on MenuItem {
        id
        name
        type

        ...SortableEntityTableRow_entity
      }
    `,
    menuItem
  );

  const { id, name, type } = menuItemData;

  return (
    <SortableEntityTableRow entity={menuItemData} {...props}>
      <TableCell>
        <Link href={`/content/menu-items/${id}`}>{name}</Link>
      </TableCell>

      <TableCell center>{type && types[type]}</TableCell>
    </SortableEntityTableRow>
  );
};

export default MenuItemsListRow;
